// Dependencies
require("webstrap/scaffolding");
require("webstrap/buttons");
require("webstrap/responsive-utilities");

// Copy images
require("!!asset!./img/logo.png");
require("!!asset!./img/logo-print.png");
require("!!asset!./img/ico-login.svg");
require("!!asset!./img/ico-lang.svg");

// Styles
require("./burger.scss");
require("./burger-logo.scss");
require("./burger-top.scss");
require("./burger-top-nav.scss");
require("./burger-top-desktop.scss");
require("./burger-menu.scss");
require("./burger-menu-nav.scss");
require("./burger-menu-link.scss");
require("./burger-demo.scss");
require("./burger-lang.scss");
require("./burger-subnav.scss");

// JavaScript
var $ = require("jquery");

// Ouverture / Fermeture de la navigation mobile
var $body = $('body'),
    classe = 'is-burger-open';
$('.js-burger-menu__open').on('click.sec-burger-menu', function (e) {
    e.preventDefault();
    $body.addClass(classe);
    return false;
});
$('.js-burger-menu__close, .js-burger-menu__overlay').on('click.sec-burger-menu', function (e) {
    e.preventDefault();
    $body.removeClass(classe);
    return false;
});

// Language
var $html = $('html'),
    $lang = $('.sec-burger-lang'),
    $link = $('.js-burger-lang__link', $lang),
    classeLang = 'sec-burger-lang--open';
$link.on('click.sec-burger-lang', function (e) {
    e.preventDefault();
    if ($lang.hasClass(classeLang)) {
        $lang.removeClass(classeLang);
    } else {
        $lang.addClass(classeLang);
    }
    return false;
});
$lang.on('click.sec-burger-lang', function (e) {
    e.stopPropagation();
});
$html.on('click.sec-burger-lang', function (e) {
    $lang.removeClass(classeLang);
});

// Avoid redirection if click on main nav link when sub nav is closed

Array.from(document.querySelectorAll('[data-main-menu]')).forEach((menuItem) => {
    const link = menuItem.querySelector('[data-main-menu-link');
    const subMenu = menuItem.querySelector('[data-sub-menu');

    const checkSubMenuOpacity = (e) => {
        if ((window.getComputedStyle(subMenu).opacity) == 0) {
            e.preventDefault();
            subMenu.focus();
            console.log(document.activeElement);
        }
    }

    link.addEventListener("click", checkSubMenuOpacity);
});


/*****************
 ** WEBPACK FOOTER
 ** ./LeLab.LogAlto.Web/src/modules/section/burger/index.js
 ** module id = 11
 ** module chunks = 0 1
 **/